import api from '../../../../../api/client';
import { TRANSACTION } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

export async function getTransactionsSummary(params = {}) {
  try {
    const response = await api.get(TRANSACTION.SUMMARY, {
      params,
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getTransactionRequestSummary(params = {}) {
  try {
    const response = await api.get(TRANSACTION.REQUEST_SUMMARY, {
      params,
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getTransactions(params = {}) {
  try {
    const response = await api.get(TRANSACTION.INDEX, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function rechargeAction(payload = {}) {
  try {
    const response = await api.post(TRANSACTION.RECHARGE_ACTION, payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function withdrawalAction(payload = {}) {
  try {
    const response = await api.post(TRANSACTION.WITHDRAWAL_ACTION, payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
